module.exports = __webpack_public_path__ + "static/media/salary.3d25ba55.svg";